<template>
    <div class="top">
        <div style="margin: 50px;"></div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" :rules="rules">
            <el-form-item label="修改账号"> {{token}}</el-form-item>


            <el-form-item label="旧密码" prop="theOriginalPassword">
                <el-input v-model="formLabelAlign.theOriginalPassword" class="form-item-inner" size="small"
                          placeholder="" clearable></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="formLabelAlign.newPassword" class="form-item-inner" size="small" placeholder=""
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
                <el-input v-model="formLabelAlign.confirmPassword" class="form-item-inner" size="small" placeholder=""
                          clearable></el-input>
            </el-form-item>
            <!-- 提交按钮 -->
            <div class="form-item-group">
                <el-form-item class="insert-data-form-item">
                    <el-button  size="small"   @click="resetHandler">重置</el-button>
                    <el-button
                         size="small"
                        @click="saveHandler"
                    >
                        {{ '提 交' }}
                    </el-button>
                </el-form-item>
            </div>
        </el-form>


    </div>

</template>

<script>
import {logout, updatePassword} from '@/config';
import {mapState} from 'vuex';
import _ from 'lodash';

export default {
    name: '',
    components: {},

    data() {
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value.length > 64 || value.length < 6) {
                callback(new Error('密码长度为8-12个字符'));
            } else if (!new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,12}').test(value)) {
                callback(new Error('密码必须由数字、字母、特殊字符组合,请输入8-12位'));
            } else {
                callback();
            }
        };
        return {
            labelPosition: 'right',
            formLabelAlign: {
                theOriginalPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
            rules: {
                theOriginalPassword: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '请输入旧密码'
                    },

                ],
                //    theOriginalPassword: [{required: true, validator: validatePass, trigger: 'change'}],
                newPassword: [{required: true, validator: validatePass, trigger: 'change'}],
                confirmPassword: [{required: true, validator: validatePass, trigger: 'change'}],
            }
        };
    },
    computed: {
        ...mapState({
            token: state => state.user.token
        })
    },
    mounted() {
    },
    methods: {

        async saveHandler() {
            let theOriginalPass = this.formLabelAlign.theOriginalPassword;
            let newPass = this.formLabelAlign.newPassword;
            let confirmPass = this.formLabelAlign.confirmPassword;
            // 新密码和确认密码是否一致
            if (newPass === '' || theOriginalPass === '' || confirmPass === '') {
                this.$message({
                    message: '密码不能为空！',
                    type: 'warning'
                });
                return false;
            } else if (newPass  !== confirmPass) {
                this.$message({
                    message: '新密码和确认密码不一致！',
                    type: 'warning'
                });
                return false;
            }

            let params = Object.assign({}, this.formLabelAlign);
            const insertResult = await updatePassword(params);
            if (insertResult) {
                this.$message({
                    type: 'success',
                    message: '重新登录！',
                    duration: 1000,
                    onClose: () => {
                        this.$router.replace({path: '/login'});
                    }
                });
            }


        },

        // 重置
        resetHandler() {
            this.formLabelAlign.theOriginalPassword = '';
            this.formLabelAlign.newPassword = '';
            this.formLabelAlign.confirmPassword = '';
        }
    }
};

</script>
<style lang="less">
    .top {
        width: 50%;
        height: 100%;
    }
</style>
